module.exports = __webpack_public_path__ + "media/application/images/svgs/trending-up-cde2d597da0673d45f044589fd5acebd.svg";